import styled from "styled-components";
import bottomBorder from "../../../images/hadding-suprt.jpg";

export const Container = styled.div`
  .row {
    margin-bottom: 5px;
  }
  @media screen and (max-width: 767px) {
    .row {
      margin-bottom: 0;
    }
  }
`;

export const Bold = styled.p`
  font-weight: 700;
  font-size: 18px;
`;

export const Title = styled.h3`
  width: 100%;
  float: left;
  text-align: left;
  background: url(${bottomBorder}) bottom left no-repeat;
  padding: 0 0 15px;
  margin: 50px 0 45px;
  color: #0071bc;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 700;
`;
